<template>
  <div id="zzzdhome">
    <div class="content_box">
      <div @click="goTo('eCommerce')" class="content_item">
        <div></div>
        <i>我要开网店</i>
        <span>电商资质诊断</span>
      </div>
      <div @click="goTo('live')" class="content_item">
        <div></div>
        <i>我要当主播</i>
        <span>直播资质诊断</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goTo(val) {
      switch (val) {
        case "eCommerce":
          this.$router.push({ path: "/diagnose/ECommerce/settledType" });
          break;
        case "live":
          this.$router.push({ path: "/diagnose/Liveplatform/settledType" });
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    let type = {
      headerType: true, //左侧标题
      rightName: true, //左侧标题
    };
    this.$emit("getMessage", type);
  },
};
</script>

<style lang="scss" scoped>
#zzzdhome {
  background: url("../../../assets/imgs/zzzd/homebg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .content_box {
    width: 1190px;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .content_item {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      box-shadow: 0px 20px 60px 0px rgba(202, 23, 15, 1);
      border-radius: 10px;
      align-items: center;
      width: 513px;
      height: 513px;
      background: #ffffff;
      &:first-child div {
        width: 362px;
        height: 260px;
        margin-top: 24px;
        background: url("../../../assets/imgs/zzzd/homeleft.png") no-repeat;
        background-size: 100% 100%;
      }
      &:last-child div {
        width: 360px;
        height: 211px;
        margin-top: 57px;
        background: url("../../../assets/imgs/zzzd/homeright.png") no-repeat;
        background-size: 100% 100%;
      }
      i {
        width: 200px;
        height: 56px;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(215, 68, 63, 1);
        line-height: 56px;
        margin-top: 35px;
      }
      &:last-child i{
        margin-top: 51px;
      }
      span {
        width: 240px;
        height: 56px;
        font-size: 40px;
        margin-top: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 56px;
      }
    }
  }
}
</style>